/** saves Accounts Balances
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_BALANCE = (state, payload) => {
    state.accountsBalances = payload.balanceViews
}

/** saves Accounts Balances
@payload {Object} with:
    accountId {Number} - accountId for which we changed the description
    data {Object} - object with new account description
*/
export const SAVES_NEW_ACCOUNT_DESCRIPTION = (state, { payload, responseData }) => {
    state.accountsBalances = state.accountsBalances.map(account => {
        return {
            ...account,
            description: account.id === payload.accountId ? responseData.description : account.description
        }
    })
}
